const EigenLeadsDiagramFrame = ({ theme, children, caption, className = '' }) => {
  const isDark = theme === 'dark';

  return (
    <figure className={className}>
      <div
        className={`el-diagram-shell relative overflow-hidden rounded-xl border ${
          isDark
            ? 'border-indigo-900/50 bg-[#0a0c14] shadow-[0_20px_50px_rgba(0,0,0,0.4)]'
            : 'border-indigo-200/80 bg-[#f8f9fc] shadow-[0_18px_40px_rgba(79,70,229,0.08)]'
        }`}
      >
        <div
          className={`pointer-events-none absolute inset-x-0 top-0 h-px ${
            isDark
              ? 'bg-gradient-to-r from-transparent via-indigo-500/60 to-transparent'
              : 'bg-gradient-to-r from-transparent via-indigo-600/40 to-transparent'
          }`}
        />
        <div className="relative">{children}</div>
      </div>
      {caption && (
        <figcaption
          className={`mt-3 text-[11px] uppercase tracking-[0.2em] text-center leading-snug ${
            isDark ? 'text-slate-500' : 'text-slate-400'
          }`}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default EigenLeadsDiagramFrame;
